export function hello() {
  return {
    type: 'hello'
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/Header/redux/HeaderActions.js
 **/